import React from 'react';
import '../App.css';

function ItSOverNineThousand() {
    return(
        <div className='ItSOverNineThousand'>
            <h2>It’s Over 9000 !!!</h2>
        </div>
         );
}
export default ItSOverNineThousand;